const PATH = "/api/v1/bookings";

const ENDPOINTS = {
  BOOKING_TRIPS_INVENTORY_ALL: "/trips/inventory/all/",
  BOOKING_TRIPS_INVENTORIES: "/trips/inventories/",
  BOOKING_TRIPS_PRICING: "/trips/pricing/",
  BOOKING_TRIPS_BOOKINGS: "/",
  BOOKING_SEED: "/seed/",
};

export type BookingEndpoints = keyof typeof ENDPOINTS;
export const BookingCollection = { PATH, ENDPOINTS };
